import { render, staticRenderFns } from "./editSku.vue?vue&type=template&id=3bdc149c&scoped=true&"
import script from "./editSku.vue?vue&type=script&lang=js&"
export * from "./editSku.vue?vue&type=script&lang=js&"
import style0 from "./editSku.vue?vue&type=style&index=0&id=3bdc149c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdc149c",
  null
  
)

export default component.exports